import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { satisfiesRole } from "shared";

export const Route = createFileRoute("/_authed/_onboard")({
  beforeLoad: async ({ context: { queryClient, trpc } }) => {
    const session = await queryClient.ensureQueryData(
      trpc.auth.session.queryOptions(),
    );
    const admin = satisfiesRole(session.role, "admin");

    if (!admin || session.org?.features.includes("onboarding")) {
      throw redirect({
        to: "/dashboard",
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <Outlet />
    </>
  );
}
